import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
// src/mixins/mouseCursor.ts
import { css } from "styled-components";
var mouseCursor = function mouseCursor(_ref) {
  var disabled = _ref.disabled;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    cursor: ", ";\n"])), disabled ? "not-allowed" : "pointer");
};
export { mouseCursor };